import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Initialize i18n before importing components
import './i18n';

import { AppStateProvider } from './Context/AppStateContext';
import { LanguageProvider } from './Context/LanguageContext';
import { SanityDataProvider } from './Context/SanityDataContext';
import { Dashboard, UI } from './Features';
import GlobalStyle from './globalStyles';
import { UnifiedThemeProvider } from './theme/ThemeProvider';

const router = createBrowserRouter([
  // Main portfolio page
  {
    path: '/',
    element: <Dashboard.Dashboard />,
  },
  // Norwegian SEO routes with defaultModal
  {
    path: '/om-meg',
    element: <Dashboard.Dashboard defaultModal="about" />,
  },
  {
    path: '/karriere',
    element: <Dashboard.Dashboard defaultModal="career" />,
  },
  {
    path: '/prosjekter',
    element: <Dashboard.Dashboard defaultModal="projects" />,
  },
  {
    path: '/kontakt',
    element: <Dashboard.Dashboard defaultModal="contact" />,
  },
  {
    path: '/jobbanalyse',
    element: <Dashboard.Dashboard defaultModal="jobanalysis" />,
  },
  // English SEO routes with defaultModal
  {
    path: '/en',
    element: <Dashboard.Dashboard />,
  },
  {
    path: '/en/about',
    element: <Dashboard.Dashboard defaultModal="about" />,
  },
  {
    path: '/en/career',
    element: <Dashboard.Dashboard defaultModal="career" />,
  },
  {
    path: '/en/projects',
    element: <Dashboard.Dashboard defaultModal="projects" />,
  },
  {
    path: '/en/contact',
    element: <Dashboard.Dashboard defaultModal="contact" />,
  },
  {
    path: '/en/job-analysis',
    element: <Dashboard.Dashboard defaultModal="jobanalysis" />,
  },
  {
    path: '*',
    element: <UI.NotFound />,
  },
]);

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <UnifiedThemeProvider defaultMode="dark">
        <LanguageProvider>
          <SanityDataProvider>
            <AppStateProvider>
              <GlobalStyle />
              <RouterProvider router={router} />
            </AppStateProvider>
          </SanityDataProvider>
        </LanguageProvider>
      </UnifiedThemeProvider>
    </React.StrictMode>
  );
}
